import React from 'react';
import styled from 'styled-components';
import { css } from '/imports/ui/css';

const AvatarStyled = styled.span`
  display: inline-block;
  img, .placeholder {
    border-radius: 50%;
  }
  .placeholder {
    text-align: center;
    display: flex;
    flex-direction: column;
    justify-content: space-around;
    font-weight: bold;
    background: ${css.primaryColor};
    color: #FFF !important;
  }
`;

interface AvatarProps {
  url?: string;
  fallback?: string;
  size?: string;
}

/** Circular avatar showing an image, falling back to initials. */
export const Avatar = (props: AvatarProps) => {
  const { url, fallback } = props;
  const size = props.size || '2.5rem';
  return (
    <AvatarStyled className="avatar">
      {
        url ?
          <img src={url} alt={fallback || ''} style={{ width: size, height: size }} />
          :
          <div className="placeholder" style={{ width: size, height: size }}>{fallback}</div>
      }
    </AvatarStyled>
  );
};